<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { CreditCard } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import CreditCardForm from '@/components/credit-cards/CreditCardForm.vue';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import type { SharedData } from '@/types';
    import QueryKey from '@/enums/QueryKey';

    const { t } = useI18n();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const props = defineProps<{
        creditCard: CreditCard;
    }>();

    const form = useForm({
        id: props.creditCard.id,
        name: props.creditCard.name,
        number: props.creditCard.number,
        type: props.creditCard.type,
        employee_ids: props.creditCard.assigned_ids,
        user_ids: props.creditCard.assigned_user_ids ?? [],
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="
            route('v2.credit-cards.update', {
                company: selectedCompanyId,
                creditCard: creditCard.id,
            })
        "
        :query-key="[QueryKey.CREDIT_CARDS, selectedCompanyId]"
        title="credit-cards.edit.title"
        :success-message-translated="t('credit-cards.edit.success', { name: form.name })"
    >
        <CreditCardForm :form="form" />
    </DialogForm>
</template>
